import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { updateTextForm } from 'store/Admin/Analyser';

export const useAdminReactivateInitialText = ({
  t,
  textId,
  textTitle,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const dispatch = useDispatch();

  const reactivateInitialText = () => {
    axiosPrivate
      .put(`/texts/${textId}/reactivate`)
      .then(() => {
        dispatch(updateTextForm({ key: 'activeInitialText', value: true }));

        setErrorSuccessMsg(
          `${t('Le texte initial de')} "${textTitle}" ${t('a été activé')}!`
        );
        setIsSuccess(true);
        setErrorSuccess(true);
      })
      .catch(() => {
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setIsSuccess(false);
        setErrorSuccess(true);
      });
  };

  return {
    reactivateInitialText,
  };
};
